import React from 'react'
import { FormControl, FormLabel, Select } from '@chakra-ui/react'

import { MAX_PLAY_TIME_FILTER_OPTIONS } from '../bggCollectionFilters'

/**
 * Max playing time from collection `stats` (listed time); no follow-up `/thing` call.
 */
export default function BggNumericFilters({ maxPlayTime, onMaxPlayTimeChange, disabled }) {
	const playVal = maxPlayTime != null && maxPlayTime !== '' ? String(maxPlayTime) : 'any'

	return (
		<FormControl>
			<FormLabel fontSize="xs" fontWeight="600" color="gray.500" textTransform="uppercase" letterSpacing="0.05em" mb={1}>
				Max playing time
			</FormLabel>
			<Select size="sm" rounded="lg" value={playVal} onChange={onMaxPlayTimeChange} isDisabled={disabled}>
				{MAX_PLAY_TIME_FILTER_OPTIONS.map(({ value, label }) => (
					<option key={value} value={value}>
						{label}
					</option>
				))}
			</Select>
		</FormControl>
	)
}
